// extracted by mini-css-extract-plugin
module.exports = {"headLine":"HeadLine_headLine__ZXgSe"};